export enum ReceiptTypeEnum {
  CLIENT = "client",
  STORE = "store"
}

export enum TransactionOperationEnum {
  PURCHASE = "purchase",
  WITHDRAW = "withdraw",
  POINTS = "points",
  BONUS_RETRIEVAL = "bonus_retrieval"
}
